<div class="paymentContainer" *ngIf="reservationSaveAndConfirmModel!=null">

  <h2>
    <div class="selected-class-title mt-5">
      <!-- <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faClipboard"></fa-icon> -->
      {{ 'ConfrimYourBooking' | translate }}
    </div>
  </h2>

  <div class="row">
    <div class="col-lg-9 col-md-12">
      <!--Payment Type-->
      <div class="note-bg">
        <div class="form-group mb-0">
          <!--  <mat-radio-group (change)="changeComboo($event)" [(ngModel)]="depositeType" *ngIf="depositePolicy!=null">
            <ng-container [ngSwitch]="depositePolicy.depositPolicyPaymentTypes">

              <div *ngSwitchCase="DepositPolicyPaymentTypes.FullPaymentIsRequired">
                <mat-radio-button class="mr-3" [value]="1" >
                  {{ 'FullAmount' | translate }} [{{reservationSaveAndConfirmModel.GrandTotal | number : '1.2-2'}} {{currency}}]
                </mat-radio-button>
              </div>
              <div *ngSwitchCase="DepositPolicyPaymentTypes.PercentageOfTotalCharges">
                <mat-radio-button class="mr-3" [value]="1" >
                  {{ 'FullAmount' | translate }} [{{reservationSaveAndConfirmModel.GrandTotal | number : '1.2-2'}} {{currency}}]
                </mat-radio-button>
                <mat-radio-button [value]="2">
                  {{ 'SecurityDeposit' | translate }} [{{(reservationSaveAndConfirmModel.GrandTotal*(depositePolicy.minRequiredDeposit/100)) | number : '1.2-2'}} {{currency}}] and the remaining on Pickup
                </mat-radio-button>
              </div>

            </ng-container>
          </mat-radio-group>
          <mat-radio-group [(ngModel)]="depositeType" *ngIf="depositePolicy==null">
            <mat-radio-button class="mr-3" [value]="1" >
              {{ 'FullAmount' | translate }} [{{reservationSaveAndConfirmModel.GrandTotal | number : '1.2-2'}} {{currency}}]
            </mat-radio-button>

          </mat-radio-group> -->

          <mat-radio-group (change)="changeComboo($event)" [(ngModel)]="depositeType" *ngIf="objPayment!=null">
            <ng-container *ngFor="let item of objPayment.depositPolicyPaymentTypes">
              <div [ngSwitch]="item">
                <div *ngSwitchCase="DepositPolicyPaymentTypes.FullPaymentIsRequired">
                  <mat-radio-button class="mr-3" [value]="DepositPolicyPaymentTypes.FullPaymentIsRequired"
                    [checked]="depositeType==DepositPolicyPaymentTypes.FullPaymentIsRequired">
                    {{ 'FullAmount' | translate }} [{{objPayment.fullPayment| number : '1.2-2'}} {{currency}}]

                  </mat-radio-button>
                </div>
                <div *ngSwitchCase="DepositPolicyPaymentTypes.PercentageOfTotalCharges">

                  <mat-radio-button [value]="DepositPolicyPaymentTypes.PercentageOfTotalCharges"
                    [checked]="depositeType==DepositPolicyPaymentTypes.PercentageOfTotalCharges">
                    {{ 'MinimumDeposit' | translate }} [{{objPayment.minDeposit | number : '1.2-2'}} {{currency}}]

                  </mat-radio-button>
                </div>
                <div *ngSwitchCase="DepositPolicyPaymentTypes.NoPaymentIsRequired">

                  <mat-radio-button [value]="DepositPolicyPaymentTypes.NoPaymentIsRequired"
                    [checked]="depositeType==DepositPolicyPaymentTypes.NoPaymentIsRequired">
                    {{ 'NoPaymentsIsRequired' | translate }}

                  </mat-radio-button>
                </div>
              </div>
            </ng-container>
          </mat-radio-group>

        </div>
      </div>

      <!-- for now there is no need to it -->
      <!----SAVED PAYMENT INFO---->
      <!-- <div *ngIf="customerPaymentMethods!=null&&customerPaymentMethods.length > 0">
        <h2>
          <div class="selected-class-title2">
            {{ 'SavedPaymentInfo' | translate }}:
          </div>
        </h2>

        <mat-radio-group *ngFor="let item of customerPaymentMethods" aria-label="Select an option">
          <div class="grey-bg-payment">
            <mat-radio-button value="1">
              <div class="row justify-content-center align-items-center saved-payment-booking">
                <div class="col-md-2 col-4">
                  <div *ngIf="item.typeID == 0">
                    <img class="img-fluid saved-payment-img" src="assets/img/icons/visa1.svg" />
                  </div>
                  <div *ngIf="item.typeID == 1">
                    <img class="img-fluid saved-payment-img" src="assets/img/icons/mastercard.jpg" />
                  </div>
                </div>
                <div class="col-md-3 col-4">{{item.number}}</div>
                <div class="col-md-3 col-4">{{item.name}}</div>
                <div class="col-md-2 col-4">{{item.expiryMonth}}{{item.expiryYear}}</div>
                <div class="col-md-2 col-4"><span class="cvc">{{item.cvv}}</span></div>
              </div>
            </mat-radio-button>
          </div>
        </mat-radio-group>

        <div class="custom-control custom-switch mt-3"
          *ngIf="depositeType!=DepositPolicyPaymentTypes.NoPaymentIsRequired">
          <input type="checkbox" class="custom-control-input" id="customSwitch1" [checked]="UseAnotherPayment"
            (change)="UseAnotherPayment = !UseAnotherPayment">
          <label class="custom-control-label use-another-payment" for="customSwitch1"> {{ 'Useanotherpaymentmethod' |
            translate }}</label>
        </div>
      </div> -->

      <!----SAVED PAYMENT INFO---->





      <payment-shared [rentalServiceDeliveryChannel]="RentalServiceDeliveryChannel.Online" [caseID]="reservationSaveAndConfirmModel.CaseID" [depositeType]="depositeType" [paymentMode]="PaymentMode.New"></payment-shared>




    </div>
    <div class="col-lg-3 col-md-12"></div>
  </div>






  <!-- </div> -->


</div>
